import { NamedProperty } from "sprint-common-web";

import { WatermarkRulePosition } from "../../../common/types/WatermarkRulePosition";
import { GetWatermarkRuleListItemResponse } from "../api/GetWatermarkRuleListResponse";

export interface WatermarkRuleItem {
    id: string;
    value: string;
    distributor: NamedProperty;
    position: WatermarkRulePosition;
}

export const mapToWatermarkRuleItem = (item: GetWatermarkRuleListItemResponse): WatermarkRuleItem => {
    return {
        id: item.id,
        value: item.value,
        distributor: item.distributor,
        position: item.position
    };
};
